import { ApplicationConfig, importProvidersFrom, inject } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PreloadAllModules, provideRouter, withInMemoryScrolling, withPreloading } from '@angular/router';

import { routes } from './app.routes';
import {
    HTTP_INTERCEPTORS,
    HttpClientModule,
    HttpClient,
    provideHttpClient,
    withInterceptors,
} from '@angular/common/http';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { CrudService } from '@shared/modules/crud/crud.service';
import { FirebaseLibService } from '@shared/modules/firebase/firebase-lib.service';

import { environment } from 'src/environments/environment';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getFunctions, provideFunctions } from '@angular/fire/functions';
import { getMessaging, provideMessaging } from '@angular/fire/messaging';
import { getStorage, provideStorage } from '@angular/fire/storage';
import {
    getRemoteConfig,
    provideRemoteConfig,
} from '@angular/fire/remote-config';
import {provideAnimations} from '@angular/platform-browser/animations';
import { httpLoadingInterceptor } from '@core/interceptors/http-loading.interceptor';
import { ViewportScroller } from '@angular/common';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http);
}

export const appConfig: ApplicationConfig = {
    providers: [
          provideRouter(routes,withInMemoryScrolling({
                anchorScrolling: 'enabled',
                scrollPositionRestoration: 'enabled'
            }), withPreloading(PreloadAllModules)),
            
        importProvidersFrom([
            BrowserAnimationsModule,
            HttpClientModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: HttpLoaderFactory,
                    deps: [HttpClient],
                },
            }),
        ]),
        { provide: CrudService, useClass: FirebaseLibService },
        MessageService,
        ConfirmationService,
        provideFirebaseApp(() => initializeApp(environment.firebase)),
        provideAuth(() => getAuth()),
        provideFirestore(() => getFirestore()),
        provideFunctions(() => getFunctions()),
        provideMessaging(() => getMessaging()),
        provideStorage(() => getStorage()),
        provideRemoteConfig(() => getRemoteConfig()),
        provideAnimations(),
        provideHttpClient(
            withInterceptors([httpLoadingInterceptor])
            ),
    ],
};
